namespace RioERP.Reports {
    export interface FranchiseeSalesReportRow {
        Id?: number;
        InvoiceDate?: string;
        OrderDate?: string;
        Invoicenumber?: string;
        EPaymentType?: number;
        CustomerName?: string;
        EInvoiceTo?: number;
        FranchiseeName?: string;
        FranchiseeGstin?: string;
        City?: string;
        StateName?: string;
        ProductName?: string;
        ProductId?: number;
        OrderNumber?: string;
        FranchiseeDiscountAmount?: number;
        OrderDiscount?: number;
        ProductDiscount?: number;
        TaxCategoryName?: string;
        InvoiceCompanyId?: number;
        Total?: number;
        DiscountAmount?: number;
        NetAmount?: number;
        TaxableAmount?: number;
        CgstRate?: number;
        CgstAmount?: number;
        SgstRate?: number;
        SgstAmount?: number;
        IgstRate?: number;
        IgstAmount?: number;
        TotalTax?: number;
        EPaymentStatus?: number;
        InvoiceId?: number;
        FranchiseeId?: number;
        CustomerId?: number;
    }

    export namespace FranchiseeSalesReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Invoicenumber';
        export const localTextPrefix = 'Reports.FranchiseeSalesReport';
        export const deletePermission = 'Reports:ReportsManagement:Modify';
        export const insertPermission = 'Reports:ReportsManagement:Modify';
        export const readPermission = 'Reports:ReportsManagement:View';
        export const updatePermission = 'Reports:ReportsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            InvoiceDate = "InvoiceDate",
            OrderDate = "OrderDate",
            Invoicenumber = "Invoicenumber",
            EPaymentType = "EPaymentType",
            CustomerName = "CustomerName",
            EInvoiceTo = "EInvoiceTo",
            FranchiseeName = "FranchiseeName",
            FranchiseeGstin = "FranchiseeGstin",
            City = "City",
            StateName = "StateName",
            ProductName = "ProductName",
            ProductId = "ProductId",
            OrderNumber = "OrderNumber",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            OrderDiscount = "OrderDiscount",
            ProductDiscount = "ProductDiscount",
            TaxCategoryName = "TaxCategoryName",
            InvoiceCompanyId = "InvoiceCompanyId",
            Total = "Total",
            DiscountAmount = "DiscountAmount",
            NetAmount = "NetAmount",
            TaxableAmount = "TaxableAmount",
            CgstRate = "CgstRate",
            CgstAmount = "CgstAmount",
            SgstRate = "SgstRate",
            SgstAmount = "SgstAmount",
            IgstRate = "IgstRate",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax",
            EPaymentStatus = "EPaymentStatus",
            InvoiceId = "InvoiceId",
            FranchiseeId = "FranchiseeId",
            CustomerId = "CustomerId"
        }
    }
}
